module.exports = __webpack_public_path__ + "assets/img/pingtaiyoushiCover4.329e3eb3.jpg";